import axios from 'src/axios';

import { APICONSTANTS } from 'src/components/Constants';

let statusCache = null;

const UNAVAILABLE = { enabled: false, countries: [] };

const STATUS_TTL_MS = 30 * 1000;

export function fetchPlacesStatus(fhqToken) {
  const key = fhqToken || 'session';
  const now = Date.now();

  if (
    statusCache &&
    statusCache.key === key &&
    now - statusCache.at < STATUS_TTL_MS
  ) {
    return statusCache.promise;
  }

  let promise;
  try {
    promise = Promise.resolve(
      axios.post(APICONSTANTS.placesStatus, { fhqToken })
    )
      .then((res) => ({
        enabled: Boolean(res?.data?.enabled),
        countries: Array.isArray(res?.data?.countries) ? res.data.countries : []
      }))
      .catch(() => UNAVAILABLE);
  } catch {
    promise = Promise.resolve(UNAVAILABLE);
  }

  statusCache = { key, at: now, promise };
  return promise;
}

export function resetPlacesStatusCache() {
  statusCache = null;
}

export function createSessionToken() {
  const uuid = globalThis.crypto?.randomUUID?.();
  if (uuid) return uuid;
  return `s-${Date.now().toString(36)}-${Math.random()
    .toString(36)
    .slice(2, 10)}`;
}

export async function fetchSuggestions({
  input,
  regionCodes,
  sessionToken,
  fhqToken
}) {
  const { data } = await axios.post(APICONSTANTS.placesAutocomplete, {
    input,
    regionCodes,
    sessionToken,
    fhqToken
  });
  return data?.suggestions || [];
}

export async function fetchPlaceDetails({ placeId, sessionToken, fhqToken }) {
  const { data } = await axios.post(APICONSTANTS.placesDetails, {
    placeId,
    sessionToken,
    fhqToken
  });
  return {
    addressComponents: data?.addressComponents || [],
    formattedAddress: data?.formattedAddress || ''
  };
}
